<template>
    <div class="dropdown">
        <b-button-group>
            <button class="btn btn-white" @click="clear" v-if="localValue && localValue.length>0">
                <span class="fe fe-x"></span>
            </button>
            <b-dropdown variant="white" top :text="label" no-flip class="p-0 m-0">
                <div class="dropdown-item pl-2 p-0 m-0" style="width:400px; ">
                    <b-form-input class="form-control-flush m-0" size="sm" placeholder="email@example.com"></b-form-input>
                </div>

                <b-list-group flush style=" overflow:scroll; " class="m-0">
                    <b-list-group-item
                        v-for="(tag, index) in allitems"
                        :key="index"
                        @click="label=tag.label; currentService = tag._id"
                        class="pointer"
                    >
                        <span class="pl-3">{{tag.label}}</span>
                        <b-list-group v-if="currentService == tag._id">
                            <b-list-group-item
                                v-for="(child, index) in tag.children"
                                class="pointer"
                                href="#"
                                :key="index"
                            >
                                <span class="pl-3">{{child.label}}</span>
                            </b-list-group-item>
                        </b-list-group>
                    </b-list-group-item>
                </b-list-group>
            </b-dropdown>
        </b-button-group>
    </div>
    <!-- <b-popover :target="id" triggers="click focus" placement="bottom" class="serviceSelect p-0">
        <template v-slot:title>
            <input type="text" class="form-control" />
        </template>
        <ul class="list-group list-group-flush" style="overflow:scroll !important; height:300px;">
            <li class="list-group-item list-group-item-action pointer active">Cras justo odio</li>
            <li class="list-group-item list-group-item-action pointer">Dapibus ac facilisis in</li>
            <li class="list-group-item list-group-item-action pointer">Morbi leo risus</li>
            <li class="list-group-item list-group-item-action pointer">Porta ac consectetur ac</li>
            <li class="list-group-item list-group-item-action bg-lighter pointer pl-5">Morbi leo risus</li>
            <li class="list-group-item list-group-item-action bg-lighter pointer pl-5">Porta ac consectetur ac</li>
            <li class="list-group-item list-group-item-action pointer">Vestibulum at eros</li>
            <li class="list-group-item list-group-item-action pointer">Dapibus ac facilisis in</li>
            <li class="list-group-item list-group-item-action pointer">Morbi leo risus</li>
            <li class="list-group-item list-group-item-action pointer">Porta ac consectetur ac</li>
            <li class="list-group-item list-group-item-action pointer">Vestibulum at eros</li>
        </ul>
    </b-popover>-->
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';


import { mapGetters, mapState } from 'vuex';

export default {
    props: ['value', 'id'],
    components: {
        Treeselect
    },
    data() {
        return {
            localValue: null,
            label: null,
            currentService: null
        }
    },
    watch: {
        localValue(newValue) {
            this.$emit('input', newValue);
            this.$emit('change', newValue);
        }

    },
    computed: {
        ...mapGetters('service', { findServicesInStore: 'find' }),
        ...mapState('service', { areServicesLoading: 'isFindPending' }),
        ...mapState('treatment', { areTreatmentsLoading: 'isFindPending' }),
        ...mapGetters('treatment', { findTreatmentInStore: 'find' }),
        services() {
            return this.findServicesInStore({ query: { public: true, $sort: { priority: 1 } } }).data;
        },
        allitems() {
            let services = this.findServicesInStore({ query: { public: true, $sort: { priority: 1 } } }).data;
            services.map(service => {
                service.children = this.findTreatmentInStore({
                    query: {
                        serviceId: service._id,
                        public: true,
                    }
                }).data;
            })
            return services;
        }

    },
    created() {
        this.localValue = this.value;
    },
    methods: {
        normalizer(item) {
            item.id = item._id;
            return item;
        },
        isCurrent(value) {
            return value == this.localValue;
        },
        updateValue() {
            console.log('update value');

            this.$emit('input', this.localValue);
            this.$emit('change', this.localValue);
        },
        treatments(serviceId) {
            return this.findTreatmentInStore({
                query: {
                    serviceId,
                    public: true,
                }
            }).data;
        }
    }

}
</script>

<style>
.popover{
    max-width:450px;
        width: 50%;
        
}
</style>
